import React from 'react';
import type { FreemiumBannerOdeditorProps } from '../FreemiumBannerOdeditor.types';
import FreemiumBannerResponsiveCommon from '../../FreemiumBannerResponsive/viewer/FreemiumBannerResponsiveCommon';
import { OdeditorLogo } from './assets/OdeditorLogo';
import style from './style/FreemiumBannerOdeditorLive.scss';

const FreemiumBannerOdeditor: React.FC<FreemiumBannerOdeditorProps> = ({
  textBeforeLogo = 'Built on',
  logoText,
  ...rest
}) => (
  <FreemiumBannerResponsiveCommon
    styles={{ root: style.root, text: style.text, link: style.link }}
    useOverlay={false}
    textAfterLogo=""
    textBeforeLogo={textBeforeLogo}
    logoText={logoText || 'Wix Harmony'}
    {...rest}
  >
    <OdeditorLogo logoText={logoText} className={style.logo} />
  </FreemiumBannerResponsiveCommon>
);

export default FreemiumBannerOdeditor;
